<template>
    <nav class="pagination">
        <ul>
            <li v-if="!isInFirstPage">
                <a @click="onClickPage(1)" class="prev">
                    <figure>
                        <span class="inline-svg" style="padding-top: 162.5%">
                            <icon-arrow />
                        </span>
                    </figure>
                </a>
            </li>

            <!-- Visible Buttons Start -->
            <li class="link" v-for="(page, index) in totalPages" :key="index">
                <template v-if="isPageActive(index + 1)">
                    <div>{{ index }}</div>
                </template>
                <template v-else>
                    <a @click="onClickPage(index + 1)" :data-page="index">{{ index + 1 }}</a>
                </template>
            </li>
            <!-- Visible Buttons End -->

            <li v-if="!isInLastPage">
                <a @click="onClickPage(currentPage + 1)" class="next">
                    <figure>
                        <span class="inline-svg" style="padding-top: 162.5%">
                            <icon-arrow />
                        </span>
                    </figure>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        totalPages: {
            type: Number,
            required: true,
            default: 1,
        },
        perPage: {
            type: Number,
            required: true,
            default: 1,
        },
        currentPage: {
            type: Number,
            required: true,
            default: 1,
        },
        pageCount: {
            type: Number,
            required: true,
            default: 1,
        },
    },
    computed: {
        isInFirstPage() {
            return this.currentPage === 1
        },
        isInLastPage() {
            return this.currentPage === this.totalPages
        },
    },
    methods: {
        isPageActive(page) {
            return this.currentPage === page
        },
        onClickFirstPage() {
            this.$emit('pagechanged', 1)
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1)
        },
        onClickPage(page) {
            this.$emit('pagechanged', page)
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1)
        },
        onClickLastPage() {
            this.$emit('pagechanged', this.totalPages)
        },
    },
}
</script>

<style>
.pagination {
    list-style-type: none;
}

.pagination-item {
    display: inline-block;
}

.active {
    background-color: #4aae9b;
    color: #ffffff;
}
</style>
